<template>
    <div style="text-align: center">
        <el-empty :description="$t('placeholder.siteIsErrToVisit')"></el-empty>
        <a href="javascript:location.reload();">
            <el-button type="primary">{{$t('actions.refresh')}}</el-button>
        </a>
    </div>
</template>
<script setup>
import { $t } from "~/utils/index.js";
</script>
<style lang="less" scoped>

</style>